(() => {
  'use strict';
  const script = document.querySelector('script[data-mn-content-tracking]');
  if (!script || window.mnContentClickBound) return;
  window.mnContentClickBound = true;
  function permitted() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const contentType = script.dataset.contentType === 'recipe' ? 'recipe' : 'article';
  let lastLink = null;
  let lastTime = 0;
  function record(event) {
    if ((event.type === 'auxclick' && event.button !== 1) || !permitted()) return;
    const link = event.target.closest?.('a[href]');
    if (!link || !link.closest('main, .mn-abar')) return;
    let destination;
    try { destination = new URL(link.href, location.origin); } catch (_) { return; }
    if (destination.origin !== location.origin) return;
    const path = destination.pathname;
    const normalized = path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
    let kind = '';
    if (/^\/(?:collections\/[^/]+\/)?products\/[^/]+\/?$/.test(normalized)) kind = 'product';
    else if (/^\/collections\/[^/]+\/?$/.test(normalized)) kind = 'collection';
    else if (/^\/pages\/(feigenmarmelade-kaufen|heidelbeermarmelade-kaufen|prova-minnelea)\/?$/.test(normalized)) kind = 'commercial_page';
    if (!kind || typeof window.Shopify?.analytics?.publish !== 'function') return;
    const now = Date.now();
    if (lastLink === link && now - lastTime < 600) return;
    lastLink = link; lastTime = now;
    const placement = link.dataset.mnlPlacement || link.closest('[data-mnl-placement]')?.dataset.mnlPlacement || (link.closest('.mn-abar') ? 'article-sticky-offer' : contentType + '-body');
    window.Shopify.analytics.publish('minnelea_content_product_click', {
      source_path: location.pathname,
      destination_path: path,
      destination_type: kind,
      placement: placement.slice(0,80),
      article_id: script.dataset.articleId || '',
      recipe_id: script.dataset.recipeId || '',
      content_type: contentType,
      language: document.documentElement.lang,
      version: '2'
    });
  }
  document.addEventListener('click', record, true);
  document.addEventListener('auxclick', record, true);
})();
